module.exports = __webpack_public_path__ + "img/347.80c1b404.jpg";